import Amplify from "@aws-amplify/core";

export const initAmplify = () =>
  Amplify.configure({
    Auth: {
      identityPoolId: window.env.COGNITO_IDENTITY_POOL_ID,
      region: window.env.COGNITO_REGION,
      userPoolId: window.env.COGNITO_USER_POOL_ID,
      userPoolWebClientId: window.env.COGNITO_CLIENT_ID,
      endpoint: window.env.COGNITO_ENDPOINT,
      authenticationFlowType: window.env.COGNITO_AUTH_FLOW,
      mandatorySignIn: false,
      cookieStorage: {
        domain: window.location.hostname,
        path: "/",
        expires: 7,
        secure: window.env.ENV === "PROD",
      },
    },
    Storage: {
      bucket: window.env.COGNITO_BUCKET,
    },
  });
